import forEach from 'lodash/forEach';
import mapValues from 'lodash/mapValues';

import {
  ERROR_ALLOCATED_BUDGET_EXCEEDS,
  ERROR_C_METRICS_LESS,
} from './constants';

const validateActivityType = ({
  budget,
  budgetAllocated,
  metrics,
  cMetrics,
}) => {
  const errors = {
    budgetAllocated: [],
    cMetrics: mapValues(cMetrics, () => []),
  };

  if (budgetAllocated > budget) {
    errors.budgetAllocated.push({
      type: ERROR_ALLOCATED_BUDGET_EXCEEDS,
      payload: {
        budget,
        budgetAllocated,
      },
    });
  }

  forEach(cMetrics, (value, key) => {
    if (value.value < metrics[key]) {
      errors.cMetrics[key].push({
        type: ERROR_C_METRICS_LESS,
      });
    }
  });

  return errors;
};

const validateDepth = ({ nodes, activityTypes, name }) => {
  const nodeErrors = nodes.map(validateDepth);

  return {
    activityTypes: mapValues(activityTypes, (values, activityType) => {
      const activityTypeErrors = validateActivityType(values);
      return mapValues(activityTypeErrors, (errors, type) => {
        if (type === 'budgetAllocated') {
          const newErrors = errors.map(error => ({
            ...error,
            activityType,
            path: [name],
          }));

          return [
            ...newErrors,
            ...nodeErrors
              .map(({ activityTypes }) => {
                const errors = activityTypes[activityType]?.budgetAllocated;
                return errors
                  ? errors.map(({ path, ...error }) => ({
                      ...error,
                      path: [name, ...path],
                    }))
                  : [];
              })
              .flat(),
          ];
        }
        return errors;
      });
    }),
    nodes: nodeErrors,
  };
};

export default validateDepth;
